import findOrThrow from "../../../array/findOrThrow";
import { IMarket } from "../../../markets/type";

class CurrentMarket {
    useCurrentMarket(markets: IMarket[], selectedId: string): IMarket {
        return findOrThrow(markets, ({id}) => id === selectedId);
    }
}

export default new CurrentMarket();